/* eslint-disable */
import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { styled } from '@material-ui/core/styles';
import { Card, CardHeader } from '@material-ui/core';
import _ from 'lodash';
import dashboardService from './DashboardService';
import TokenDecoder from '../../../helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';

const CHART_HEIGHT = 392;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2),
  '& .apexcharts-canvas svg': {
    height: CHART_HEIGHT
  },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

export default function AppCurrentSubject() {
  const OpID = parseInt(TokenDecoder.getGroupFactoryToken().factory);
  const [data, setData] = useState([]);
  const [names, setNames] = useState([]);
  useEffect(() => {
    trackPromise(GetData());
  }, []);

  async function GetData() {
    const response = await dashboardService.GetProductDetailsForRadialGraphInDasboard(OpID);
    let res = _.cloneDeep(response);
    const arr = Object.values(res);

    let namesArray = [];
    let valueArray = [];

    arr.forEach(x => {
      x.forEach(y => {
        valueArray.push(y.count);
      })
    });

    let plotCategoriesSet = response.plotCategoriesSet;
    let plotMethodsSet = response.plotMethodsSet;
    let plotTypesSet = response.plotTypesSet;

    plotCategoriesSet.forEach(x => {
      x.id == 1 ? namesArray.push("Modernize") :
        namesArray.push("Non Modernize")
    });
    plotTypesSet.forEach(x => {
      x.id == 1 ? namesArray.push("Tunnel") :
        namesArray.push("Plot")
    });
    plotMethodsSet.forEach(x => {
      {
        x.id == 1 ? namesArray.push("Bee safe") :
          x.id == 2 ? namesArray.push("Gap") :
            x.id == 3 ? namesArray.push("Normal") :
              null
      }
    })
    setNames(namesArray);
    setData(valueArray);

  }


  let randomColorGenerator = function () {
    return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
  };

  let colorArray = []
  names.forEach(element => {
    colorArray.push(randomColorGenerator())
  });

  const state = {
    series: data,
    options: {
      colors: colorArray,
      chart: {
        type: 'radialBar',
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: '22px',
            },
            value: {
              fontSize: '16px',
              formatter: function (value) {
                const percent = (value / 1);
                return percent.toFixed(0)
              },
            },
            total: {
              show: false,
              label: 'Total',
              formatter: function (w) {
                // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                return 249
              }
            },

          }
        }
      },
      labels: names,
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
      }

    },
  };

  return (
    <>
      <LoadingComponent />
      <Card>
        <CardHeader title="Product Plots" />
        <ChartWrapperStyle dir="ltr" >
          <ReactApexChart type="radialBar" options={state.options} series={state.series} height={400} />
        </ChartWrapperStyle>
      </Card>
    </>
  );
}

